export const aboutStrings = {
    en:{
        aboutMeTitle1:"About me",
        aboutMeTitle2:"Knowing me more",
        iAm: "I'm",
        aboutMeContent1:"I help companies build reliable, scalable IT systems — from initial analysis through implementation to long-term maintenance.\n" +
            "\n" +
            "With over 25 years in the industry, I have delivered solutions across a wide range of business domains: CRM systems, order management, training platforms, e-commerce, and REST microservices. I know what works in production — and what doesn't.\n" +
            "\n" +
            "My approach is straightforward: I start with your business problem, not the technology. You get a partner who understands both sides — the code and the business impact.",
        yearsExperience: "Years Experiance",
        happyCustomers: "Happy customers",
        projectsDone: "Projects",
        numbersSummary: "These numbers represent peace of mind and guarantee that your project will be delivered on time and according to agreement."
    },
    pl: {
        aboutMeTitle1:"O mnie",
        aboutMeTitle2:"Poznajmy się",
        iAm: "Jestem",
        aboutMeContent1:"Pomagam firmom budować niezawodne, skalowalne systemy IT — od analizy potrzeb, przez wdrożenie, aż po długoterminowe utrzymanie.\n" +
            "\n" +
            "Przez ponad 25 lat zrealizowałem projekty z różnych dziedzin: systemy CRM, zarządzanie zleceniami, platformy szkoleniowe, e-commerce oraz mikrousługi REST. Wiem, co działa na produkcji — i czego unikać.\n" +
            "\n" +
            "Moje podejście jest proste: zaczynam od Twojego problemu biznesowego, nie od technologii. Otrzymujesz partnera, który rozumie obie strony — kod i jego wpływ na Twój biznes.",
        yearsExperience: "Lata doświadczenia",
        happyCustomers: "Zadowoleni klienci",
        projectsDone: "Projekty",
        numbersSummary: "Te liczby oznaczają spokój i gwarancję, że Twój projekt zostanie zrealizowany na czas i zgodnie z ustaleniami."
    },
};

export default aboutStrings;